import React from "react";
import ReactDOM from "react-dom";
class CreatALertnew extends React.Component {
  state = {
    areas: [],
    city_id: null
  }
  constructor(props) {
    super(props);
    this.areas_cities = this.areas_cities.bind(this)
  }
  areas_cities(event){
    let _city_id = event.target.value;
    let _url = `${BASE.url}areas-by-city-id/${_city_id}`;
    fetch(_url)
    .then(res => res.json())
    .then(res => {
        this.setState({
          areas: res.data,
          city_id: _city_id
        });
    });
  }
  render() {
    let categories = window.CATEGORIES;
    let cities = window.CITIES_DATA;
    let _areas = this.state.areas
    return (
        <div className='CreatALertnew'>
        <div className="content">
            <div className="alert-form-inputs">
                <div className="input-field">
                    <select required className="input input-select" name="category_id" required>
                        <option selected disabled value="">{modalV4.select_categoy}</option>
                        {categories && categories.data.map(item => (
                            <option key={item.id} value={item.id}>
                            {item.category_name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="input-field">
                    <select value={this.state.city_id} className="input input-select" onChange={this.areas_cities} name="city_id" required>
                        <option selected disabled value="">{modalV4.choose_city}</option>
                        {cities && cities.map(city => (
                        <option key={city.city_id} value={city.city_id}>
                            {city.city_name}
                        </option>
                        ))}
                    </select>
                </div>
                {_areas && _areas.length ? 
                    <div className="input-field">
                        <select className="input input-select" name="area_id" required id="area_id">
                            <option selected disabled value="">{modalV4.choose_area}</option>
                            {_areas && _areas.map(area => (
                            <option key={area.id} value={area.id}>
                                {area.name}
                            </option>
                            ))}
                        </select>
                    </div> 
                : null }
                <div className="input-field">
                    <input className="input input-basic" dir="" type="text" placeholder={modalV4.price_from} name="price_from" />
                </div>
                <div className="input-field ">
                    <input className="input input-basic" dir="" type="text" placeholder={modalV4.price_to} name="price_to"/>
                </div>
            </div>
            
            <div className="alert-form-actions">
                    <input type="submit"  className="btn primary-1-btn" value={modalV4.alert_submit}/>
                    <span className="input-field-hint">{modalV4.alert_message}</span>
    
                </div>
        </div>
    </div>
    );
  }
}

const CreatALerts = document.getElementById("CreatALert");
if (CreatALerts) {
  ReactDOM.render(<CreatALertnew />, CreatALerts);
}